import React from 'react'
import NotificationPng from '../../assets/images/noti.svg';
import Icon from './icon'


const NotificationIcon = () => <Icon src={NotificationPng} />


export const NavBarData = [
    {
        to: '/notification',
        icon: <NotificationIcon />
    },
    {
        label: 'Settings',
        to: '/home',
    },
    {
        label: 'Maintenance',
        to: '/maintainance',
    },
    {
        label: 'Reserve Now',
        to: '/home',
    },
    {
        label: 'My Bookings',
        to: '/myBooking',
    },
    {
        to: '/profile',
        label: 'profileIcon'
    },
]

export const FooterData = [
    {
        label: 'Report Issue',
        to: '/report',
    },
    {
        label: 'Legal Terms',
        to: '/home',
    },
    {
        label: 'FAQs',
        to: '/home',
    },
    {
        label: 'Support',
        to: '/home',
    },
]